var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33453_63893)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.664062,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EA002C",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.666 13.6615C10.666 15.0759 11.2279 16.4325 12.2281 17.4327C13.2283 18.4329 14.5849 18.9948 15.9993 18.9948C17.4138 18.9948 18.7704 18.4329 19.7706 17.4327C20.7708 16.4325 21.3327 15.0759 21.3327 13.6615C21.3327 12.247 20.7708 10.8904 19.7706 9.89022C18.7704 8.89003 17.4138 8.32812 15.9993 8.32812C14.5849 8.32813 13.2283 8.89003 12.2281 9.89022C11.2279 10.8904 10.666 12.247 10.666 13.6615Z",
    stroke: "#EA002C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 32.6615V29.5503C6.66602 27.9001 7.32157 26.3175 8.48846 25.1506C9.65536 23.9837 11.238 23.3281 12.8882 23.3281H19.1105C20.7607 23.3281 22.3433 23.9837 23.5102 25.1506C24.6771 26.3175 25.3327 27.9001 25.3327 29.5503V32.6615",
    stroke: "#EA002C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33453_63893"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.664062,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.96fd91d46fe368eeb263226caee37b6f.svg";
export { ForwardRef as ReactComponent };